import api from '../../lib/api';

// Una sola richiesta per pagina: la usano sia la galleria tendenze sia le card dei servizi
let pending = null;

export function loadPublicTrends() {
  if (!pending) {
    pending = api.get('/website-trends/public')
      .then((r) => (Array.isArray(r.data) ? r.data : []))
      .catch(() => {
        pending = null; // al prossimo montaggio si riprova
        return [];
      });
  }
  return pending;
}
